export const ESSENTIAL_DISCOUNT = 1 - 0.4; // Fixed discount of 40%
export const PER_DAY = 12 / 365; // to calculate prices GB/day

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30CloudNative = '30BHY';
